import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import { IProvider, IPoint, IAddress } from '../../models';


const TEMED_HOST = process.env.TEMED_HOST;
const CONSULT_HOST = process.env.CONSULT_HOST;

const MAP_DEFAULT_OPTIONS = () => {
  return {
    zoom: 13
  }
};

@Component({
  template: require('./TemedMap.html'),
  props:{
    center: Object,
    zoom: Number,
    options: Object,
    offices: Array
  }
})
export class TemedMap extends Vue {

  temedHost: string = TEMED_HOST;
  consultHost: string = CONSULT_HOST;

  @Prop({ default: MAP_DEFAULT_OPTIONS })
  options: object;

  @Prop()
  center: IPoint;

  @Prop({ default: 13 })
  zoom: number;

  @Prop({ default: [] })
  offices: IAddress[];

  $map: google.maps.Map = null;

  $markers: google.maps.Marker[] = [];


  mounted () {
    this.initMap();
  }


  initMap(){
    const element = this.$refs['temed-map'] as Element;
    const latLng = new google.maps.LatLng(this.center.latitude, this.center.longitude);
    const options = { center: latLng, zoom: this.zoom };
    this.$map = new google.maps.Map(element, options);
    this.$markers = [];
    google.maps.event.addListenerOnce(this.$map, 'idle', this.onBoundsChanged);
    this.initMarkers();
  }

  @Watch('offices')
  initMarkers(){

    this.$markers.forEach((marker: google.maps.Marker) => {
      marker.setMap(null);
    });
    this.$markers = [];

    this.offices.forEach(office => {
      const latLng = new google.maps.LatLng(office.latitude, office.longitude);
      const options = { position: latLng, map: this.$map };
      const marker = new google.maps.Marker(options);
      marker.addListener('click', () => this.markerClick({ marker, office }));
      this.$markers.push(marker);
    });
    google.maps.event.addListenerOnce(this.$map, 'bounds_changed', this.onBoundsChanged)
    this.fitToMarkers();
  }


  markerClick(payload){
    const latLng = new google.maps.LatLng(payload.office.latitude, payload.office.longitude);
    this.$map.setCenter(latLng);
  }


  fitToMarkers(){
    const bounds = new google.maps.LatLngBounds();
    for(const marker of this.$markers){
      bounds.extend(marker.getPosition());
    }
    this.$map.fitBounds(bounds);
  }

  onBoundsChanged(){

    if(this.$map.getZoom() > this.zoom){
      this.$map.setZoom(this.zoom);
    }
  }
}
